export default __webpack_public_path__ + "static/media/bike.0be9d83c.png";